import { render, staticRenderFns } from "./todo-list-card.vue?vue&type=template&id=505b9fde&scoped=true"
import script from "./todo-list-card.vue?vue&type=script&lang=js"
export * from "./todo-list-card.vue?vue&type=script&lang=js"
import style0 from "./todo-list-card.vue?vue&type=style&index=0&id=505b9fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b9fde",
  null
  
)

export default component.exports